import React, { Component } from "react";
import { connect } from "react-redux";
import { successAlertDispatcher } from "../../redux/actions/alertAction";
import { translate } from "react-i18next";
import { isEmpty } from "lodash";
import { discardShipmentDispatcher, createShipmentDispatcher } from "../../redux/actions/shipmentAction";

import UpdateTitleBar from "../../components/titleBar/updateOrder_titleBar";
import EditNewOrder from "../../components/newEditOrderComponent/editNewOrder";

class EditOrder extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    }

    componentDidMount() {
    }

    onFormSubmit = () => {
        this.props.history.push("/shipment");
    };

    render() {
        const { t } = this.props;
        // const { routeCode, routeName} = this.state;
        return (
            <React.Fragment>
                <UpdateTitleBar className="page-heading"
                    Title={"Edit Shipment"}
                    LinkName="/edit-order"

                />

                <div className="m-2">
                    <EditNewOrder></EditNewOrder>
                </div>

            </React.Fragment>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        discardShipment: () => dispatch(discardShipmentDispatcher()),
        createShipment: (shipment) => dispatch(createShipmentDispatcher(shipment, false)),
        successAlert: (alert) => dispatch(successAlertDispatcher(alert)),
    };
};
export default connect(
    null,
    mapDispatchToProps
)(translate("shipment")(EditOrder));
